<template>
  <div>
    <v-row v-if="moduleWidget == 'banner' && getBannerSlide.length > 0">
      <v-col class="mx-0 px-0">
        <swiper :style="swiperStyles" class="swiper" :options="swiperOption">
          <swiper-slide v-for="pic in getBannerSlide" :key="pic.id">
            <!-- <div
              style="
                width: 100%;
                height: 100%;
                border-radius: 8px;
                overflow: hidden;
              "
            >
              <img
                :src="pic.image_url"
                @click.once="handleClick('clickBanner', pic)"
              />
            </div> -->
            <img
              :src="pic.image_url"
              style="
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
                border-radius: 10px;
                object-fit: contain;
                display: block;
                margin: 0 auto;
              "
              @click="handleClick('clickBanner', pic)"
            />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </v-col>
    </v-row>

    <v-row v-if="moduleWidget == 'friend' && site.is_use_friend == 'Y'">
      <v-col class="mx-0 px-0">
        <div class="px-4">
          <v-row>
            <v-col class="d-flex justify-space-between align-center" cols="12">
              <div
                class="d-flex align-center px-3"
                style="
                  height: 32px;
                  border-radius: 16px;
                  background-color: #ffffffa6;
                  border: 2px solid #ffffffcc;
                "
              >
                <p class="mb-0" style="font-weight: bold">
                  {{ $t("friendRecommend") }}
                </p>
              </div>
              <p class="mb-0" style="color: #707070">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge
                      :color="totalRequest > 0 ? 'red' : 'transparent'"
                      dot
                    >
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon> mdi-dots-horizontal </v-icon>
                      </v-btn>
                    </v-badge>
                  </template>

                  <v-list>
                    <v-list-item>
                      <v-list-item-title
                        @click="handleClick('goToFriendPage', 'recommend')"
                      >
                        {{ $t("friendRecommend") }}</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title
                        @click="handleClick('goToFriendPage', 'request')"
                        >{{ $t("friendRequest") }}
                        <v-chip
                          x-small
                          color="red"
                          dark
                          v-if="totalRequest != 0"
                          >{{ totalRequest }}</v-chip
                        >
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title
                        @click="handleClick('goToFriendPage', 'friend')"
                        >{{ $t("friendList") }}</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </p>
            </v-col>
          </v-row>
          <listFriendRecommend
            :site="site"
            :dataItems="dataFriendRecommend"
            :cardTitleFriend="cardTitleFriend"
            @addFriend="addFriend"
          />
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="
        moduleWidget == 'activity_coming' &&
        dataMissionComing.length > 0 &&
        site.menu_mission_hot == 'active'
      "
    >
      <v-col class="mx-0 px-0">
        <div class="px-4">
          <v-row>
            <v-col class="d-flex justify-space-between align-center" cols="12">
              <div
                class="d-flex align-center px-3"
                style="
                  height: 32px;
                  border-radius: 16px;
                  background-color: #ffffffa6;
                  border: 2px solid #ffffffcc;
                "
              >
                <p class="mb-0" style="font-weight: bold">
                  {{ site.menu_mission_hot_text }}
                </p>
              </div>
              <v-chip
                color="blue lighten-5"
                style="color: #0d47a1; font-weight: 500; cursor: pointer"
                @click="handleClick('goToListActivityComing')"
              >
                {{ $t("viewAll") }}
              </v-chip>
            </v-col>
          </v-row>
          <listMissionHorizontal
            :site="site"
            :dataItems="dataMissionComing"
            typeActivity="active"
          />
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="
        moduleWidget == 'activity_recommend' &&
        dataMission.length > 0 &&
        site.menu_mission_suggest == 'active'
      "
    >
      <v-col class="mx-0 px-0">
        <div class="px-4">
          <v-row>
            <v-col class="d-flex justify-space-between align-center" cols="12">
              <div
                class="d-flex align-center px-3"
                style="
                  height: 32px;
                  border-radius: 16px;
                  background-color: #ffffffa6;
                  border: 2px solid #ffffffcc;
                "
              >
                <p class="mb-0" style="font-weight: bold">
                  {{ site.menu_mission_suggest_text }}
                </p>
              </div>
              <v-chip
                color="orange lighten-5"
                style="color: #e65100; font-weight: 500; cursor: pointer"
                @click="handleClick('goToListActivityRecommended')"
              >
                {{ $t("viewAll") }}
              </v-chip>
            </v-col>
          </v-row>
          <listMissionHorizontal
            :site="site"
            :dataItems="dataMission"
            typeActivity="active"
          />
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="
        moduleWidget == 'reward' &&
        rewardItem.length > 0 &&
        site.menu_reward == 'active'
      "
    >
      <v-col class="mx-0 px-0">
        <div class="px-4">
          <v-row>
            <v-col class="d-flex justify-space-between align-center" cols="12">
              <div
                class="d-flex align-center px-3"
                style="
                  height: 32px;
                  border-radius: 16px;
                  background-color: #ffffffa6;
                  border: 2px solid #ffffffcc;
                "
              >
                <p class="mb-0" style="font-weight: bold">
                  {{ site.menu_reward_text }}
                </p>
              </div>
              <v-chip
                color="green lighten-5"
                style="color: #1b5e20; font-weight: 500; cursor: pointer"
                @click="handleClick('goToRewardSoHot')"
              >
                {{ $t("viewAll") }}
              </v-chip>
            </v-col>
          </v-row>
          <listRewardHorizontal
            :site="site"
            :dataItems="rewardItem"
            @fetchData="getHotReward"
          />
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="
        moduleWidget == 'blog' &&
        dataBlog.length != 0 &&
        site.menu_blog == 'active'
      "
    >
      <v-col class="mx-0 px-0">
        <div class="px-4">
          <v-row>
            <v-col class="d-flex justify-space-between align-center" cols="12">
              <div
                class="d-flex align-center px-3"
                style="
                  height: 32px;
                  border-radius: 16px;
                  background-color: #ffffffa6;
                  border: 2px solid #ffffffcc;
                "
              >
                <p class="mb-0" style="font-weight: bold">
                  {{ site.menu_blog_text }}
                </p>
              </div>
              <v-chip
                color="purple lighten-5"
                style="color: #4a148c; font-weight: 500; cursor: pointer"
                @click="handleClick('goToNews')"
              >
                {{ $t("viewAll") }}
              </v-chip>
            </v-col>
          </v-row>
          <listBlog :site="site" :dataItems="dataBlog" typeActivity="active" />
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="
        moduleWidget == 'game' &&
        dataGamification.length > 0 &&
        site.menu_game == 'active'
      "
    >
      <v-col class="mx-0 px-0">
        <div class="px-4">
          <v-row>
            <v-col class="d-flex justify-space-between align-center" cols="12">
              <div
                class="d-flex align-center px-3"
                style="
                  height: 32px;
                  border-radius: 16px;
                  background-color: #ffffffa6;
                  border: 2px solid #ffffffcc;
                "
              >
                <p class="mb-0" style="font-weight: bold">
                  {{ site.menu_game_text }}
                </p>
              </div>
              <v-chip
                color="#FCE4EC"
                style="color: #c51162; font-weight: 500; cursor: pointer"
                @click="handleClick('goToGamification')"
              >
                {{ $t("viewAll") }}
              </v-chip>
            </v-col>
          </v-row>
          <listGamification
            :site="site"
            :dataItems="dataGamification"
            typeActivity="active"
          />
        </div>
      </v-col>
    </v-row>

    <v-skeleton-loader
      v-if="moduleWidget == 'banner' && !loadedModule"
      class="my-2"
      type="card"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-if="moduleWidget == 'friend' && !loadedModule"
      class="my-2"
      type="card"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-if="moduleWidget == 'activity_coming' && !loadedModule"
      class="my-2"
      type="card"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-if="moduleWidget == 'activity_recommend' && !loadedModule"
      class="my-2"
      type="card"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-if="moduleWidget == 'reward' && !loadedModule"
      class="my-2"
      type="card"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-if="moduleWidget == 'blog' && !loadedModule"
      class="my-2"
      type="card"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-if="moduleWidget == 'game' && !loadedModule"
      class="my-2"
      type="card"
    ></v-skeleton-loader>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import listMissionHorizontal from "@/components/listMissionHorizontal.vue";
import listFriendRecommend from "@/components/listFriendRecommend.vue";
import listBlog from "@/components/listBlog.vue";
import listRewardHorizontal from "@/components/listRewardHorizontal.vue";
import listGamification from "@/components/listGamification.vue";

export default {
  props: {
    site: { default: null },
    moduleWidget: { default: null },
    loadedModule: { default: true },
    getBannerSlide: { default: null },
    totalRequest: { default: null },
    dataFriendRecommend: { default: null },
    cardTitleFriend: { default: null },
    dataMissionComing: { default: null },
    dataMission: { default: null },
    rewardItem: { default: null },
    dataBlog: { default: null },
    dataGamification: { default: null },
  },
  components: {
    swiper,
    swiperSlide,
    listRewardHorizontal,
    listMissionHorizontal,
    listBlog,
    listFriendRecommend,
    listGamification,
  },
  data: () => ({
    swiperOption: {
      slidesPerView: "auto",
      loop: true,
      speed: 500,
      autoplay: {
        enabled: true,
        delay: 5000,
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      },
      effect: "coverflow",
      centeredSlides: true,
      spaceBetween: 40,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
  }),
  created() {},
  mounted() {},
  methods: {
    handleClick(func, param) {
      let detail = {
        func: func,
        param: param,
      };
      this.$emit("onClick", detail);
    },
    getHotReward(param) {
      this.$emit("getHotReward", param);
    },
    addFriend(param) {
      this.$emit("addFriend", param);
    },
  },
  computed: {
    swiperStyles() {
      return {
        "--swiper-pagination-color": this.site.color,
        // "--swiper-pagination-bullet-inactive-color": "#999999",
        // "--swiper-pagination-bullet-inactive-opacity": "1",
        // "--swiper-pagination-bullet-size": "16px",
        // "--swiper-pagination-bullet-horizontal-gap": "6px"
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn--absolute.v-btn--top,
.v-btn--fixed.v-btn--top {
  top: 5px;
}
.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: 5px;
}

.custom-header {
  margin-top: -130px;
  margin-bottom: -55px;
}
@media only screen and (min-width: 768px) {
  .custom-header {
    width: 45%;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}

.user-img {
  width: 50px;
}

.swiper-pagination-bullets {
  bottom: -6px;
}

.swiper {
  width: 100%;
  padding-bottom: 20px;
}

.swiper-slide {
  display: flex;
  // border-radius: 10px !important;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-size: cover;
  width: 300px;
  height: 160px;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  // object-fit: contain;
  object-fit: cover;
}

@media only screen and (min-width: 600px) {
  .swiper-slide {
    width: 550px;
    height: 160px;
    max-height: 160px;
  }
}

@media only screen and (min-width: 960px) {
  .swiper-slide {
    width: 750px;
    height: 240px;
    max-height: 240px;
  }
}

@media only screen and (min-width: 768px) {
  .sticky {
    position: absolute !important;
    top: 0;
    width: 100%;
    background-color: transparent; /* Background color when sticky */
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); /* Box shadow when sticky */
  }
}
.fixed-row {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
.container1 {
  position: relative;
}

.header-container {
  transition: background-color 0.3s, box-shadow 0.3s;
}

.header {
  background-color: transparent; /* Initial background color */
  box-shadow: none; /* Initial box shadow */
  position: absolute;
  z-index: 10;
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: transparent; /* Background color when sticky */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); /* Box shadow when sticky */
}
</style>

<style scope>
.v-btn__content {
  display: flex;
  flex-direction: column;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}

.bar-image {
  height: 210px;
  font-size: 14px;
}

.v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}
.v-btn--absolute.v-btn--top,
.v-btn--fixed.v-btn--top {
  top: 3px;
}
.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: 5px;
}

.v-slide-group__content {
  justify-content: start !important;
}
.container2 {
  position: relative;
}
.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}
.div-popup {
  max-width: "800px";
}
</style>
